import type { SerializedCheckIn } from './types/checkin';
import type { DsnComponents } from './types/dsn';
import type { CheckInEnvelope, CheckInItem, DynamicSamplingContext } from './types/envelope';
import type { SdkMetadata } from './types/sdkmetadata';
import { dsnToString } from './utils/dsn';
import { createEnvelope } from './utils/envelope';
import { safeDateNow } from './utils/randomSafeContext';

/**
 * Create envelope from check in item.
 */
export function createCheckInEnvelope(
  checkIn: SerializedCheckIn,
  dynamicSamplingContext?: Partial<DynamicSamplingContext>,
  metadata?: SdkMetadata,
  tunnel?: string,
  dsn?: DsnComponents,
): CheckInEnvelope {
  const headers: CheckInEnvelope[0] = {
    sent_at: new Date(safeDateNow()).toISOString(),
  };

  if (metadata?.sdk) {
    headers.sdk = {
      name: metadata.sdk.name,
      version: metadata.sdk.version,
    };
  }

  if (!!tunnel && !!dsn) {
    headers.dsn = dsnToString(dsn);
  }

  if (dynamicSamplingContext) {
    headers.trace = dynamicSamplingContext as DynamicSamplingContext;
  }

  const item = createCheckInEnvelopeItem(checkIn);
  return createEnvelope<CheckInEnvelope>(headers, [item]);
}

function createCheckInEnvelopeItem(checkIn: SerializedCheckIn): CheckInItem {
  const checkInHeaders: CheckInItem[0] = {
    type: 'check_in',
  };
  return [checkInHeaders, checkIn];
}



// WEBPACK FOOTER //
// ../../src/checkin.ts